import React from 'react';
import PropTypes from 'prop-types';
import { Button, } from 'react-bootstrap';
import Grid from '../../grid/Grid';
import FieldSet from '../../fieldset/FieldSet';
import SearchBar from '../../searchbar/SearchBar';
import Confirm from '../../confirm/Confirm';
import EbillingService from '../../../service/EbillService';
import EbillingEnrollmentDetailModal from './EbillingEnrollmentDetailModal';

class EbillingView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accounts: [],
      selectedAccount: null,
      enrollmentUpdateMessage: null,
      unenrollConfirmationOpen: false,
      isLoading: false,
    };
    this.serachBar = React.createRef();
    this.comboFields = [
      {
        value: 'customerId',
        display: 'Customer ID',
      },
      {
        value: 'serviceOfferingId',
        display: 'Service Offering ID',
      },
    ];
  }

  componentDidMount() {
    const { requestedState, } = this.props;
    if (requestedState) {
      this.statefulInitialization(requestedState);
    }
  }

  statefulInitialization() {
    const { click, } = this;
    if (click) {
      click();
    }
  }

  handleUnenrollConfirmationOpen = () => {
    this.setState({ unenrollConfirmationOpen: true, });
  };

  handleUnenrollConfirmationClose = () => {
    this.setState({ unenrollConfirmationOpen: false, });
  };

  getEbillingAccounts = (searchFields, onCompletion = () => {}) => {
    EbillingService.searchEbillingEnrollments(searchFields)
      .then(response => {
        this.setState({
          accounts: response.data.accounts,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        onCompletion();
      });
  };

  unenroll = () => {
    const { selectedAccount, } = this.state;
    this.setState({
      enrollmentUpdateMessage: `Unenrolling enrollment with id: ${selectedAccount.ebillingEnrollmentId}`,
      isLoading: true,
    });
    EbillingService.updateEbillingEnrollment({
      ebillingEnrollmentId: selectedAccount.ebillingEnrollmentId,
      ebillingEnrollmentStatus: 'UNENROLLED',
    }).then(() => {
      this.setState({
        enrollmentUpdateMessage: `Unenrolled enrollment with id: ${selectedAccount.ebillingEnrollmentId}\n`,
      });
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
      this.setState({
        unenrollConfirmationOpen: false,
        isLoading: false,
      });
    });
  };

  reset = () => {
    this.setState({
      accounts: [],
      selectedAccount: null,
      enrollmentUpdateMessage: null,
    });
  };

  onSearch = (event) => {
    this.reset();
    const { search, combo, } = event;
    const { requestedState = {}, } = this.props;
    const { id = '', } = requestedState;

    const searchField = {};
    if (id && !search.value) {
      searchField.customerId = id;
    } else {
      searchField[combo.value] = search.value;
    }

    this.getEbillingAccounts(searchField, event.kill);
  };

  onRowSelect = (row) => {
    this.setState({ selectedAccount: row, });
  };

  renderEbillingEnrollmentDetails = () => {
    const { accounts, selectedAccount, } = this.state;

    if (!selectedAccount) {
      return null;
    }

    const rawEnrollmentDetails = accounts.find(account => account._id === selectedAccount.ebillingEnrollmentId);

    return (
      <>
        <p>{`Selected Enrollment: ${selectedAccount.ebillingEnrollmentId}`}</p>
        <hr />
        <EbillingEnrollmentDetailModal selectedAccount={rawEnrollmentDetails} />
      </>
    );
  };

  renderUnenrollButton = () => {
    const {
      selectedAccount,
      enrollmentUpdateMessage,
      unenrollConfirmationOpen,
      isLoading,
    } = this.state;

    if (!selectedAccount || selectedAccount.enrollmentStatus !== 'ENROLLED') {
      return null;
    }

    return (
      <>
        <Button
          variant='primary'
          onClick={this.handleUnenrollConfirmationOpen}
          style={{ marginLeft: '10px', }}
        >
          Unenroll
        </Button>
        <Confirm
          isLoading={isLoading}
          title="Unenroll eBilling Enrollment"
          content={`Are you sure you want to unenroll enrollment with id: ${selectedAccount.ebillingEnrollmentId}?`}
          open={unenrollConfirmationOpen}
          onClose={this.handleUnenrollConfirmationClose}
          onYes={this.unenroll}
          onNo={this.handleUnenrollConfirmationClose}
        />
        {enrollmentUpdateMessage && <p style={{ marginTop: '10px', }}>{enrollmentUpdateMessage}</p>}
      </>
    );
  };

  renderResults = () => {
    const { accounts, } = this.state;
    if (!accounts) {
      return null;
    }

    const headers = [
      {
        value: 'customerId',
        display: 'Customer ID',
      },
      {
        value: 'ebillingEnrollmentId',
        display: 'eBilling Enrollment ID',
      },
      {
        value: 'accountId',
        display: 'Account Id',
      },
      {
        value: 'externalAccountId',
        display: 'External Account ID',
      },
      {
        value: 'serviceOfferingId',
        display: 'Service Offering',
      },
      {
        value: 'enrollmentStatus',
        display: 'Status',
      },
      {
        value: 'createdAtDate',
        display: 'Creation Date',
      },
      {
        value: 'lastUpdatedDate',
        display: 'Last Updated Date',
      },
    ];

    const rows = accounts.map(account => ({
      value: [
        account.customerId,
        account._id,
        account.accountId,
        account.externalAccountId,
        account.serviceOfferingId,
        account.enrollmentStatus,
        account.createdAt,
        account.enrollmentStatusUpdatedAt,
      ],
    }));

    return (
      <div style={{ marginTop: '20px', }}>
        <FieldSet title='eBilling Enrollments' style={{ maxHeight: '500px', }}>
          <Grid
            headers={headers}
            rows={rows}
            onRowSelect={this.onRowSelect}
          />
        </FieldSet>
        <div style={{ marginTop: '20px', }}>
          {this.renderEbillingEnrollmentDetails()}
          {this.renderUnenrollButton()}
        </div>
      </div>
    );
  };

  _setClickEvent(click) {
    this.click = click;
  }

  render() {
    const { customerId = '', } = this.state;
    return (
      <div className='container'>
        <SearchBar
          comboFields={this.comboFields}
          defaultText={customerId}
          onClick={this.onSearch}
          clickConsumer={click => this._setClickEvent(click)}
        />
        {this.renderResults()}
      </div>
    );
  }
}

EbillingView.defaultProps = {
  requestedState: undefined,
};

EbillingView.propTypes = {
  requestedState: PropTypes.string,
};

export default EbillingView;
